module.exports = __webpack_public_path__ + "img/play.85354bbe.gif";